import { ContactTypeCreatePage } from "@/features/contact-type/pages/ContactTypeCreate";
import React from "react";

const ContactTypeCreate = () => {
  return <ContactTypeCreatePage />;
};

export default ContactTypeCreate;
